import services from './services';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

export default {
    mixins: [services],
    data() {
        return {
            dialogVisible: false,
            lists: [], //代理商列表
            pageIndex: 1,
            pageSize: 10,
            totalSize: '', //分页总数
            pageSizes: [10, 20, 50], //分页类型
            query: this.getFormData(),
            title: '',
            agentId: '',
            isShowAgent: false,
            placeholder: ''
        }
    },
    methods: {
        getFormData() {
            return cloneDeep({
                Code: '',
                Name: '',
                ProvinceId: '',
                CityId: '',
                AreaId: '',
                keyWord: ''
            });
        },
        show(options) {
            this.title = options.title
            this.dialogVisible = true;
            this.isShowAgent = true;
            this.placeholder = '公司名字/主联系人/联系电话'
            this.pageIndex = 1
            this.getAgentList()

        },
        search() {
            this.getAgentList() //获取代理商列表
        },

        //选择代理商 
        chooseList(item) {
            item.title = this.title;
            this.$emit('dialogList', item)
            this.query = this.getFormData(); //清空搜索条件
            this.dialogVisible = false;
        },
        // 分页操作
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.getAgentList()

        }, //分页选定行
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.getAgentList()
        },
    },
    computed: {

    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/zqwOrder/components/chooseDialog/vm.js